/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('settingModelAir',{
                parent: 'app',
                url: '/settingModelAir', /*/:id*/
                params: {
                    makerId_modelId: "",
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/ssr/settingModelAir/modelAir.html',
                        controller: 'modelAirCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['modelAir']);// load json
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('itineraryListRevenue')
                            }],
                            'modelAircrafts': ['modelAircraftService', function(modelAircraftService){
                                return modelAircraftService.getModelAircrafts()
                            }],
                            categories: ['tariffClassService',function(tariffClassService){
                                return tariffClassService.getFareClassesFare();
                            }],
                            routesItineraries: ['modelAirService','$stateParams', function (modelAirService,$stateParams) {
                                return modelAirService.findModelAircraftSsr($stateParams.makerId_modelId, $stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
    }
})();


